// extracted by mini-css-extract-plugin
export default {"fullWidth":"Uo-z","image":"Vo-z","lazyLoadPicture":"Wo-z","lazyLoadSpinner":"Xo-z","lazyLoadSpin":"Yo-z","lazyLoadImage":"Zo-z","hasStyledAspectRatio":"_o-z"};